module.exports = __webpack_public_path__ + "img/store_create_stock.a3a91e0c.png";